<template>
  <div class="tab-recent">
    <v-container class="extended right tw-flex tw-relative tw-min-h-full">
      <div class="main-content tw-w-full tw-min-w-0">
        <v-sheet :outlined="false" v-for="item in sections" :key="item" :id="_.camelCase(item)" class="tw-border-none tw-mt-12">
          <v-card-title>{{ item }}</v-card-title>
          <v-container v-if="!_.isEmpty(records)" class="tw--mt-10">
            <component :is="`the-tab-recent-${_.kebabCase(item)}-chart`" :records="records" />
          </v-container>
        </v-sheet>
      </div>
      <table-of-content :toc="toc" class="tw-bg-transparent tw-sticky tw-mt-16" />
    </v-container>
  </div>
</template>

<script>
import TableOfContent from '@/components/common/TableOfContent'
import TheTabRecentAirTemperatureChart from '@/components/pages/station/TheTabRecentAirTemperatureChart'
import TheTabRecentSoilTemperatureChart from '@/components/pages/station/TheTabRecentSoilTemperatureChart'
import TheTabRecentSoilMoistureChart from '@/components/pages/station/TheTabRecentSoilMoistureChart'
import TheTabRecentPrecipitationChart from '@/components/pages/station/TheTabRecentPrecipitationChart'
import TheTabRecentHumidityChart from '@/components/pages/station/TheTabRecentHumidityChart'
import TheTabRecentWaterLevelChart from '@/components/pages/station/TheTabRecentWaterLevelChart'
import TheTabRecentWindSpeedChart from '@/components/pages/station/TheTabRecentWindSpeedChart'
import TheTabRecentPotentialEvapotranspirationChart from '@/components/pages/station/TheTabRecentPotentialEvapotranspirationChart'
export default {
  name: 'TheTabRecent',
  props: {
    records: {
      type: Array
    }
  },
  components: {
    TheTabRecentPotentialEvapotranspirationChart,
    TheTabRecentWindSpeedChart,
    TheTabRecentHumidityChart,
    TheTabRecentPrecipitationChart,
    TheTabRecentAirTemperatureChart,
    TheTabRecentSoilTemperatureChart,
    TheTabRecentSoilMoistureChart,
    TheTabRecentWaterLevelChart,
    TableOfContent
  },
  computed: {
    sections () {
      const output = this._.cloneDeep(this.toc)
      output.shift()
      return output
    }
  },
  data () {
    return {
      toc: [
        'Summary',
        'Air Temperature',
        'Soil Temperature',
        'Precipitation',
        'Soil Moisture',
        'Humidity',
        'Wind Speed',
        'Potential Evapotranspiration',
        'Water Level'
      ]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
